import { cn } from '../../utils/cn';
const baseClasses = 'inline-flex h-8 w-8 shrink-0 items-center justify-center [&_svg]:h-4 [&_svg]:w-4';
const shapeClasses = {
    square: 'rounded-none',
    round: 'rounded-full',
};
const variantClasses = {
    darkGrey: 'bg-interactive-loud text-interactive hover:text-interactive-hover hover:bg-interactive-louder',
    grey: 'bg-interactive text-interactive hover:text-interactive-hover hover:bg-interactive-loud',
};
// Disabled appearance, driven by base-ui's `data-disabled` styling hook (IconButton only).
const disabledClasses = 'data-disabled:cursor-not-allowed data-disabled:bg-interactive-disabled data-disabled:text-interactive-disabled data-disabled:hover:bg-interactive-disabled';
// Single source of Tailwind classes shared by `IconButton` (an action) and `IconButtonLink`
// (navigation).
export const iconButtonStyles = ({ variant = 'darkGrey', shape = 'square', className, }) => cn(baseClasses, shapeClasses[shape], variantClasses[variant], disabledClasses, className);
